import React, { useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import "./LocationPickerDialog.css";

const DEFAULT_CENTER = { lat: 41.9028, lng: 12.4964 }; // Rome — arbitrary, only used if there's no initial coordinate at all

// "Pick a point on the map" for a guide's Base Location — mirrors mobile's
// MapDialog.js (GuideEdit.js's "From map" option): tap the map to drop/move
// a pin, then confirm. No geocoding/address search on either platform —
// this is deliberately just "point at a spot," matching the "From place"
// option's own equally simple "reuse a place's exact coordinates" approach.
const LocationPickerDialog = ({ show, onHide, initialLat, initialLongi, onConfirm }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
    language: "en",
  });

  const hasInitial = Number.isFinite(initialLat) && Number.isFinite(initialLongi) && !(initialLat === 0 && initialLongi === 0);
  const [marker, setMarker] = useState(
    hasInitial ? { lat: initialLat, lng: initialLongi } : DEFAULT_CENTER
  );

  const onMapClick = useCallback((e) => {
    setMarker({ lat: e.latLng.lat(), lng: e.latLng.lng() });
  }, []);

  const confirm = () => {
    onConfirm(marker.lat, marker.lng);
    onHide();
  };

  return (
    <div className="modal">
      <Modal show={show} onHide={onHide} animation={false} dialogClassName="lpd-dialog" aria-labelledby="lpd-title" centered>
        <Modal.Body style={{ padding: 0 }}>
          <div className="lpd-shell">
            <div className="lpd-header">
              <div className="lpd-header-icon">
                <FontAwesomeIcon icon={solid("map-location-dot")} />
              </div>
              <h2 className="lpd-title" id="lpd-title">Pick a Location</h2>
              <button className="lpd-close" onClick={onHide}>
                <FontAwesomeIcon icon={solid("xmark")} />
              </button>
            </div>

            <span className="lpd-hint">Tap the map to place the pin.</span>

            <div className="lpd-map-wrap">
              {isLoaded ? (
                <GoogleMap
                  mapContainerClassName="lpd-map"
                  center={marker}
                  zoom={hasInitial ? 11 : 4}
                  onClick={onMapClick}
                  options={{ streetViewControl: false, mapTypeControl: false, fullscreenControl: false }}
                >
                  <Marker position={marker} draggable onDragEnd={onMapClick} />
                </GoogleMap>
              ) : (
                <div className="lpd-map-loading">Loading map…</div>
              )}
            </div>

            <span className="lpd-coords">{marker.lat.toFixed(6)}, {marker.lng.toFixed(6)}</span>

            <div className="lpd-footer">
              <button className="lpd-btn lpd-btn-cancel" onClick={onHide}>Cancel</button>
              <button className="lpd-btn lpd-btn-action" onClick={confirm}>Use This Location</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default LocationPickerDialog;
